import { render, staticRenderFns } from "./ChangeControlFooterComponent.vue?vue&type=template&id=b3db8802"
import script from "./ChangeControlFooterComponent.vue?vue&type=script&lang=js"
export * from "./ChangeControlFooterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports